import { GithubLogoIcon, LockKeyIcon, ShieldCheckIcon } from '@phosphor-icons/react';
import { useI18n } from '../i18n';

export function Footer() {
  const { t } = useI18n();

  return (
    <footer className="app-footer">
      <span>
        <LockKeyIcon aria-hidden="true" /> {t('footer.localOnly')}
      </span>
      <span>
        <ShieldCheckIcon aria-hidden="true" /> {t('footer.noUploads')}
      </span>
      <span>{t('footer.noAnalytics')}</span>
      <span>{t('footer.license')}</span>
      <a href="https://github.com/KanadeK/what-the-ignore" target="_blank" rel="noreferrer">
        <GithubLogoIcon aria-hidden="true" /> GitHub
      </a>
    </footer>
  );
}
